<template>
  <div class="selectMfaSetting">
    <account-header />
    <h5 class="selectMfaSetting_desc">
      不正アクセス対策のため、パスワードに加え、登録しているデバイスの多要素認証を設定します。
    </h5>
    <v-divider class="selectMfaSetting_divider" />
    <section class="selectMfaSetting_content">
      <article class="selectMfaSetting_item">
        <app-check2
          no-border
          :value="selectedMFA === 'TOTP'"
          is-group
          :class="{ 'selectMfaSetting_item--selected': selectedMFA === 'TOTP' }"
          @input="handleCheck($event, 'TOTP')"
        >
          Authenticatorアプリを使用する</app-check2
        >
      </article>
      <article v-if="false" class="selectMfaSetting_item">
        <app-check2
          no-border
          :value="selectedMFA === 'SMS'"
          is-group
          :class="{ 'selectMfaSetting_item--selected': selectedMFA === 'SMS' }"
          @input="handleCheck($event, 'SMS')"
        >
          電話番号に認証コードを送信する</app-check2
        >
        <h6
          v-show="selectedMFA === 'SMS' && phoneNumber"
          class="selectMfaSetting_phone"
        >
          {{ phoneNumber }}
        </h6>
      </article>
      <article class="selectMfaSetting_item">
        <app-check2
          no-border
          :value="selectedMFA === 'NOMFA'"
          is-group
          :class="{
            'selectMfaSetting_item--selected': selectedMFA === 'NOMFA',
          }"
          @input="handleCheck($event, 'NOMFA')"
        >
          多要素認証を使用しない</app-check2
        >
      </article>
    </section>
    <div class="selectMfaSetting_action">
      <v-btn
        class="selectMfaSetting_btn-submit"
        :disabled="submitDisabled"
        :loading="submitLoading"
        @click="handleSubmit"
      >
        次へ
      </v-btn>
    </div>
  </div>
</template>

<script>
import { authService } from '@/services/auth.service';
import AccountHeader from '../AccountHeader.vue';

export default {
  name: 'SelectMfaSetting',
  components: {
    AccountHeader,
  },
  data() {
    return {
      submitLoading: false,
      selectedMFA: 'NOMFA',
      currentMFA: 'NOMFA',
      phoneNumber: null,
    };
  },
  computed: {
    submitDisabled() {
      return this.currentMFA === this.selectedMFA && this.selectedMFA !== 'SMS';
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    handleSubmit() {
      this.routerPush({
        name: `account-mfa-${this.selectedMFA.toLowerCase()}`,
      });
    },
    async init() {
      let selectedMFA = await authService.getCurrentUserMFA();
      if (selectedMFA === 'SOFTWARE_TOKEN_MFA') {
        selectedMFA = 'TOTP';
      } else if (selectedMFA === 'SMS_MFA') {
        selectedMFA = 'SMS';
      }
      this.selectedMFA = selectedMFA;
      this.currentMFA = selectedMFA;
      const phoneNumber = await authService.getUserPhone();
      if (phoneNumber) {
        this.phoneNumber = phoneNumber;
      }
    },
    handleCheck(checked, item) {
      this.selectedMFA = item;
    },
  },
};
</script>

<style lang="scss">
.selectMfaSetting {
  overflow: auto;
  height: 100%;

  &_desc {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #666;
    margin-top: 5px;
  }

  &_phone {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #989898;
    padding-left: 30px;
  }

  &_item {
    padding: 15px 0;
    user-select: none;
    &:not(:last-child) {
      border-bottom: solid 1px #eeeeee;
    }
    &--selected {
      .customCheck2_label {
        color: #0075c2;
      }
    }
  }
  &_divider {
    margin-top: 16px;
    &.theme--light.v-divider {
      border-color: #ccc;
    }
  }
  &_gap-header {
    height: 26px;
  }
  &_action {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-top: 1px solid #ccc;
    &-delete {
      padding: 9px 0;
    }
    padding: 15px 0;
    h3 {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
    }
  }
  &_btn {
    &-submit {
      &.theme--light.v-btn.v-btn--has-bg {
        width: 120px;
        height: 36px;
        margin: 0 680px 0 0;
        padding: 8px 16px;
        border-radius: 5px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
        background-color: #0075c2;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.14;
        letter-spacing: normal;
        text-align: left;
        color: #fff;
      }
      &.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
        background-color: #f3f3f3 !important;
        box-shadow: none;
        color: #ccc !important;
      }
    }

    &-delete {
      .icon-trash {
        font-size: 16px;
        color: #989898;
      }
    }
  }
}
</style>
